import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, ButtonBase } from '@mui/material';
import LogoSection from '../../layout/MainLayout/LogoSection';
import ProfileSection from '../../layout/MainLayout/Header/ProfileSection';
const Header = () => {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          width: 228,
          display: 'flex',
          height: 75,
          alignItems: 'center',
          [theme.breakpoints.down('md')]: {
            width: 'auto',
          },
        }}
      >
        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden',mr:"15px" }}>
        </ButtonBase>
        <Box
          component="span"
          sx={{ textAlign:"center",display: { md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <ProfileSection />
    </>
  );
};

export default Header;
